import Marquee from "react-fast-marquee";

const ITEMS = [
  "Context Graph",
  "Correlation Engine",
  "Change Observability",
  "Institutional Intelligence",
  "Decision Continuity",
  "Signal Correlation",
  "Drift Detection",
  "Organizational Memory",
];

export default function EditorialMarquee() {
  return (
    <div className="border-y border-white/10 bg-surface py-6" data-testid="editorial-marquee">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="mx-8 flex items-center gap-16 font-mono text-xs uppercase tracking-[0.3em] text-white/35">
            {item}
            <span className="ml-16 block h-1 w-1 rounded-full bg-signal/70" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
